import { render, staticRenderFns } from "./CompleteText.vue?vue&type=template&id=96c1ecda&scoped=true&"
import script from "./CompleteText.vue?vue&type=script&lang=js&"
export * from "./CompleteText.vue?vue&type=script&lang=js&"
import style0 from "./CompleteText.vue?vue&type=style&index=0&id=96c1ecda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c1ecda",
  null
  
)

export default component.exports